import { createReducer, on } from "@ngrx/store";
import { LearnerState, initialLearnerState } from "./learner.state";
import { DeleteLearners, DeleteLearnersError, DeleteLearnersSuccess, GetCurrentPageNumber, GetCurrentPageNumberError, GetCurrentPageNumberSuccess, GetGroupLearnerCount, GetGroupLearnerCountError, GetGroupLearnerCountSuccess, GetLearnerTable, GetLearnerTableError, GetLearnerTableLength, GetLearnerTableLengthError, GetLearnerTableLengthSuccess, GetLearnerTableSuccess, ResetLearnerState, ResetLearnerTable, ResetLearnerTableError, ResetLearnerTableSuccess, SetMultipleLearnerIds, UpdateLearnerTable, UpdateStatus, UpdateStatusError, UpdateStatusSuccess } from "./learner.actions";

export const LearnerReducers = createReducer(
    initialLearnerState,
    on(ResetLearnerState, (): LearnerState => {
      return initialLearnerState;
    }),
    on(ResetLearnerTable, (state): LearnerState => {
      return {
        ...state,
        learnerTableLoader: true,
        isInitialLoadFlowReset: false,
        learnerTableError: null
      };
    }),
    on(ResetLearnerTableSuccess, (state, action): LearnerState => {
      return {
        ...state,
        learnerTableLoader: false,
        isInitialLoadFlowReset: action.isInitialLoad,
        learnerTableError: null
      };
    }),
    on(ResetLearnerTableError, (state, action): LearnerState => {
      return {
        ...state,
        learnerTableLoader: false,
        learnerTableError: action.error,
        isInitialLoadFlowReset: false,
      };
    }),
    on(GetLearnerTable, (state): LearnerState => {
      return {
        ...state,
        learnerTableLoader: true,
        learnerTableError: null
      };
    }),
    on(GetLearnerTableSuccess, (state, action): LearnerState => {
      return {
        ...state,
        learnerTableLoader: false,
        learnerTableRecords: action.result,
        learnerTableError: null
      };
    }),
    on(GetLearnerTableError, (state, action): LearnerState => {
      return {
        ...state,
        learnerTableLoader: false,
        learnerTableError: action.learnerTableError,
      };
    }),
    on(GetLearnerTableLength, (state): LearnerState => {
      return {
        ...state,
        learnerTableError: null
      };
    }),
    on(GetLearnerTableLengthSuccess, (state, action): LearnerState => {
      return {
        ...state,
        learnerRecordsLength: action.length,
        learnerTableError: null
      };
    }),
    on(GetLearnerTableLengthError, (state, action): LearnerState => {
      return {
        ...state,
        learnerTableError: action.error,
      };
    }),
    on(UpdateStatus, (state): LearnerState => {
      return {
        ...state,
        learnerTableLoader: true,
        updateLearnerStatusLoader: true,
        isUpdateLearnerStatus: false
      }
    }),
    on(UpdateStatusSuccess, (state, action): LearnerState => {
      return {
        ...state,
        learnerTableLoader: false,
        updateLearnerStatusLoader: false,
        isUpdateLearnerStatus: action.isUpdatedSuccessFully
      }
    }),
    on(UpdateStatusError, (state, action): LearnerState => {
      return {
        ...state,
        learnerTableLoader: false,
        updateLearnerStatusLoader: false,
        learnerTableError: action.error,
        isUpdateLearnerStatus: true
      }
    }),
    on(GetCurrentPageNumber, (state): LearnerState => {
      return {
        ...state,
        learnerTableError: null,
        currentPageNumber: 0
      };
    }),
    on(GetCurrentPageNumberSuccess, (state, action): LearnerState => {
      return {
        ...state,
        currentPageNumber: action.currentPageNumber
      }
    }),
    on(GetCurrentPageNumberError, (state, action): LearnerState => {
      return {
        ...state,
        learnerTableError: action.error,
      }
    }),
    on(GetGroupLearnerCount, (state): LearnerState => {
      return {
        ...state,
        groupLearnerCount: null,
        groupLearnerCountError: null,
        groupLearnerCountLoader: true
      };
    }),
    on(GetGroupLearnerCountSuccess, (state, action): LearnerState => {
      return {
        ...state,
        groupLearnerCount: action.result,
        groupLearnerCountLoader: false
      };
    }),
    on(GetGroupLearnerCountError, (state, action): LearnerState => {
      return {
        ...state,
        groupLearnerCountError: action.error,
        groupLearnerCountLoader: false
      };
    }),
    on(DeleteLearners, (state): LearnerState => {
      return {
        ...state,
        deleteLearnerLoader: true,
        learnerTableLoader: true,
        isDeleteLearner: false,
        learnerTableError: null
      }
    }),
    on(DeleteLearnersSuccess, (state, action): LearnerState => {
      return {
        ...state,
        deleteLearnerLoader: false,
        learnerTableLoader: false,
        isDeleteLearner: action.isDeletedSuccessFully
      }
    }),
    on(DeleteLearnersError, (state, action): LearnerState => {
      return {
        ...state,
        deleteLearnerLoader: false,
        learnerTableLoader: false,
        isDeleteLearner: true,
        learnerTableError: action.error
      }
    }),
    on(SetMultipleLearnerIds, (state, action): LearnerState => {
      return {
        ...state,
        multipleLearnerIds: action.learnerIds,
      };
    }),
    on(UpdateLearnerTable, (state): LearnerState => {
      return {
        ...state,
        learnerTableLoader: true,
        learnerTableError: null
      };
    })
  );